export default __webpack_public_path__ + "static/media/ada_logo.c2b1fa22.svg";